import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { carouselbreakPoints } from "utils/constants";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { useWindowDimensions } from "hooks";
import "./style.scss";

const PmCarousel = ({ children, showArrows }) => {
  const newCarouselBreakPoints = { ...carouselbreakPoints };

  const { width } = useWindowDimensions();

  const isLargeScreen = width > 1024;

  if (children.length < 5)
    newCarouselBreakPoints.desktop.partialVisibilityGutter = 0;

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    return (
      <div
        className={`carousel-button-group ${
          showArrows && isLargeScreen ? "" : "d-none"
        }`}
      >
        {" "}
        <AiOutlineLeft
          className={"cursor-pointer"}
          onClick={() => previous()}
          color="#0C1575"
        />{" "}
        &nbsp; &nbsp;
        <AiOutlineRight
          onClick={() => next()}
          className="cursor-pointer"
          color="#0C1575"
        />
      </div>
    );
  };

  return (
    <Carousel
      draggable={true}
      swipeable={true}
      showDots={false}
      responsive={newCarouselBreakPoints}
      customButtonGroup={<ButtonGroup />}
      // infinite={true}
      arrows={false}
      autoPlay={false}
      shouldResetAutoplay={false}
      keyBoardControl={true}
      slidesToSlide={1}
      partialVisible={true}
      containerClass="carousel-container"
      itemClass="carousel-item-padding"
    >
      {children}
    </Carousel>
  );
};

export default PmCarousel;
